import { render, staticRenderFns } from "./PricingForm.vue?vue&type=template&id=3e496dbe&scoped=true"
import script from "./PricingForm.vue?vue&type=script&lang=js"
export * from "./PricingForm.vue?vue&type=script&lang=js"
import style0 from "./PricingForm.vue?vue&type=style&index=0&id=3e496dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e496dbe",
  null
  
)

export default component.exports